import React from 'react';

const DateRangeFilter = ({ fromDate, toDate, onFromDateChange, onToDateChange }) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id="heading-1">
        <button className="accordion-button collapsed" type="button"
          data-bs-toggle="collapse" data-bs-target="#collapse-createDate"
          aria-expanded="false">
          Created Date
        </button>
      </h2>
      <div id="collapse-createDate" className="accordion-collapse collapse"
        data-bs-parent="#accordion-filter">
        <div className="accordion-body pt-0">
          <label className="form-label">From</label>
          <div className="input-icon mb-2">
            <input
              className="form-control"
              placeholder="Select a date"
              type="date"
              value={fromDate}
              onChange={(e) => onFromDateChange(e.target.value)}
            />
            <span className="input-icon-addon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                <path d="M16 3v4" />
                <path d="M8 3v4" />
                <path d="M4 11h16" />
                <path d="M11 15h1" />
                <path d="M12 15v3" />
              </svg>
            </span>
          </div>

          <label className="form-label">To</label>
          <div className="input-icon mb-2">
            <input
              className="form-control"
              placeholder="Select a date"
              type="date"
              value={toDate}
              onChange={(e) => onToDateChange(e.target.value)}
            />
            <span className="input-icon-addon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                <path d="M16 3v4" />
                <path d="M8 3v4" />
                <path d="M4 11h16" />
                <path d="M11 15h1" />
                <path d="M12 15v3" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter; 